module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/zh-hans_3-7568715ad94c74350d5dae5b67063459.jpg";